<template>
  <div>
    <!-- Filter BRF Modal Start -->
    <b-breadcrumb-item style="border:5px;" @click="viewBRFDetails()"  class="ml-2 mr-2"><b-badge  style="font-size: 100%;color:red;"><b>View BRF</b></b-badge></b-breadcrumb-item>
    <!-- <b-button
      style="font-size: 0.675rem; margin-left: 5px; margin-bottom: 4px"
      @click="viewBRFDetails()"
      size="sm"
      variant="danger"
      class="ml-1 mr-1"
      >View BRF</b-button
    > -->
    <b-modal
      id="viewBRFDetails-modal"
      ref="viewBRFDetails-modal"
      :title="'BRF Details-' + getBRFList.BookingNo"
      size="xl"
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
    >
      <div class="row" v-if="getBRFList">
        <div class="col-md-12">
          <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
          
          <div class="card" v-if='getBRFList.TransportType'>
            <!-- v-if="getBRFList.enquiry_booking_no" -->
            <div class="card-body">
              <div class="client-details">
                 <!-- Shipping Details Section -->
                 <h6 class="card-title">Shipping Details</h6>
                <b-row>
                  <b-col md="4" class="mb-1">
                    <strong>Transport Type:</strong>
                    {{ getBRFList.TransportType  || "N/A" }}
                  </b-col>
                  <b-col md="4" class="mb-1">
                    <strong>Shipment Type:</strong>
                    {{ getBRFList.ShipemntType  || "N/A" }}
                  </b-col>
                  <b-col md="4" class="mb-1">
                    <strong>Billing Type:</strong>
                    {{ getBRFList.BillingType  || "N/A" }}
                  </b-col>
                  <b-col md="4" class="mb-1">
                    <strong>Shipper:</strong>
                    {{ getBRFList.ClientName  || "N/A" }}
                  </b-col>
                  <b-col md="4" class="mb-1">
                    <strong>Shipping Line:</strong>
                    {{ getBRFList.ShippingLine  || "N/A" }}
                  </b-col>
                  <b-col md="4" class="mb-1">
                    <strong>Empty Pickup:</strong> {{ getBRFList.EmptyPickup  || "N/A" }}
                  </b-col>
                  <b-col md="4" class="mb-1">
                    <strong>POR (Port of Receipt):</strong>
                    {{ getBRFList.Por  || "N/A" }}
                  </b-col>
                  <b-col md="4" class="mb-1">
                    <strong>POL (Port of Loading):</strong>
                    {{ getBRFList.Pol  || "N/A" }}
                  </b-col>
                  <b-col md="4" class="mb-1">
                    <strong>POD (Port of Discharge):</strong>
                    {{ getBRFList.Pod  || "N/A" }}
                  </b-col>
                  <b-col md="4" class="mb-1">
                    <strong>Final POD:</strong> {{ getBRFList.Fpod  || "N/A" }}
                  </b-col>
                  <b-col md="4" class="mb-1">
                    <strong>Inco Term:</strong> {{ getBRFList.IncoTerm  || "N/A" }}
                  </b-col>
                  <b-col md="4" class="mb-1">
                    <strong>Spot/Non-Spot:</strong>
                    {{ getBRFList.SpotNonSpot  || "N/A" }}
                  </b-col>
                  <b-col md="4" class="mb-1">
                    <strong>Delivery Mode:</strong>
                    {{ getBRFList.DeliveryMode  || "N/A" }}
                  </b-col>
                  <b-col md="4" class="mb-1" v-if="getBRFList.HandoverDate">
                    <strong>Handover Date:</strong>
                    {{ getBRFList.HandoverDate  }}
                  </b-col>
                  <b-col md="4" class="mb-1">
                    <strong>ETD/SOB:</strong>
                    {{ getBRFList.Etd  }}
                  </b-col>
                </b-row>

                <hr />
                
                <!-- Container Details Section -->
                <h6 class="card-title">Container Details</h6>
                <b-row>
                  <b-col md="12">
                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th>Container Type</th>
                          <!-- <th>Container TUES</th> -->
                          <!-- <th>Currency</th> -->
                          <!-- <th>Total Containers</th> -->
                          <th>Rate Per Unit</th>
                          <th>Booking No</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in CONTAINERCOUNTArr" :key="index">
                          <td>{{ item.containerTypeName+'X'+item.brcm_tot_continer }}</td>
                          <!-- <td>{{ item.containerTypeTUES }}</td> -->
                          <!-- <td>{{ item.currencyCodeName }}</td> -->
                          <!-- <td>{{ item.brcm_tot_continer }}</td> -->
                          <td>{{ item.brcm_rate+' '+item.currencyCodeName }}</td>
                          <td>{{ item.booking_no }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </b-col>
                </b-row>

                <hr />

                <b-row>
                  <b-col md="4" class="mb-1" v-if="getBRFList.BookingNo">
                    <strong>BRF No:</strong> {{ getBRFList.BookingNo || "N/A" }}
                  </b-col>
                  <b-col md="4" class="mb-1" v-if="getBRFList.EnquiryNo">
                    <strong>Enq No:</strong> {{ getBRFList.EnquiryNo || "N/A" }}
                  </b-col>
                  <b-col md="4" class="mb-1" v-if="getBRFList.RaisedFrom">
                    <strong>Branch:</strong> {{ getBRFList.RaisedFrom  || "N/A" }}
                  </b-col>
                  <b-col md="4" class="mb-1" v-if="getBRFList.CreatedByUser">
                    <strong>Created By:</strong> {{ getBRFList.CreatedByUser || "N/A" }}
                  </b-col>
                  <b-col md="4" class="mb-1" v-if="getBRFList.CreatedAt">
                    <strong>Created At:</strong> {{ getBRFList.CreatedAt  }}
                  </b-col>
                  <b-col md="4" class="mb-1" v-if="getBRFList.CurrencyName">
                    <strong>Currency:</strong> {{ getBRFList.CurrencyName  || "N/A" }}
                  </b-col>
                  <b-col md="4" class="mb-1" v-if="getBRFList.CurrencyCountryName">
                    <strong>Currency Country:</strong>
                    {{ getBRFList.CurrencyCountryName  || "N/A" }}
                  </b-col>
                  <b-col md="4" class="mb-1" v-if="getBRFList.MasterCurrencyCode">
                    <strong>Master Currency Code:</strong>
                    {{ getBRFList.MasterCurrencyCode  || "N/A" }}
                  </b-col>
                </b-row>

                <hr />

                <!-- Booking Details Section -->
                <h6 class="card-title" v-if="getBRFList.BookingNo">Booking Details-{{ getBRFList.BookingNo  }}</h6>
                <b-row>
                  <b-col md="4" class="mb-1" v-if="getBRFList.BookingNo">
                    <strong>Booking No:</strong> {{ getBRFList.BookingNo  || "N/A" }}
                  </b-col>
                  <b-col md="4" class="mb-1" v-if="getBRFList.EnquiryNo">
                    <strong>Enquiry No:</strong> {{ getBRFList.EnquiryNo  || "N/A" }}
                  </b-col>
                  <b-col md="4" class="mb-1" v-if="getBRFList.RaNumber">
                    <strong>RA Number:</strong> {{ getBRFList.RaNumber || "N/A" }}
                  </b-col>
                  <!-- <b-col md="4" class="mb-1">
                    <strong>Quotation Till:</strong>
                    {{ BRFDetails.QuotationTill || "N/A" }}
                  </b-col> -->
                  <b-col md="4" class="mb-1">
                    <strong>Quotation Till Status:</strong>
                    {{ getBRFList.QuotationTillStatus  || "N/A" }}
                  </b-col>
                  <b-col md="4" class="mb-1" v-if="getBRFList.ValidForSail">
                    <strong>Valid For Sail:</strong>
                    {{ getBRFList.ValidForSail  || "N/A" }}
                  </b-col>
                  <b-col md="4" class="mb-1" v-if="getBRFList.ValidTill">
                    <strong>Valid Till:</strong> {{ getBRFList.ValidTill  || "N/A" }}
                  </b-col>
                  <b-col md="4" class="mb-1" v-if="getBRFList.TemplateName">
                    <strong>Template Name:</strong>
                    {{ getBRFList.TemplateName  || "N/A" }}
                  </b-col>
                  <b-col md="4" class="mb-1" v-if="getBRFList.TemplateValidTill">
                    <strong>Template Valid Till:</strong>
                    {{ getBRFList.TemplateValidTill  }}
                  </b-col>
                </b-row>

                <hr />

                <!-- Commodity Details Section -->
                <h6 class="card-title">Commodity Details</h6>
                <b-row>
                  <b-col md="4" class="mb-1" v-if="getBRFList.CommodityType">
                    <strong>Commodity Type:</strong>
                    {{ getBRFList.CommodityType  || "N/A" }}
                  </b-col>
                  <b-col md="4" class="mb-1" v-if="getBRFList.OtherCommodity">
                    <strong>Other Commodity:</strong>
                    {{ getBRFList.OtherCommodity  || "N/A" }}
                  </b-col>
                  <b-col md="4" class="mb-1" v-if="getBRFList.PackingCode">
                    <strong>Packing Code:</strong> {{ getBRFList.PackingCode  || "N/A" }}
                  </b-col>
                  <b-col md="4" class="mb-1" v-if="getBRFList.ImdgClass">
                    <strong>IMDG Class:</strong> {{ getBRFList.ImdgClass  || "N/A" }}
                  </b-col>
                  <b-col md="4" class="mb-1" v-if="getBRFList.UnNumber">
                    <strong>UN Number:</strong> {{ getBRFList.UnNumber  || "N/A" }}
                  </b-col>
                  <b-col md="4" class="mb-1" v-if="getBRFList.TemperatureRequired">
                    <strong>Temperature Required:</strong>
                    {{ getBRFList.TemperatureRequired  || "N/A" }}°C
                  </b-col>
                  <b-col md="4" class="mb-1" v-if="getBRFList.Humidity">
                    <strong>Humidity:</strong> {{ getBRFList.Humidity  || "N/A" }}
                  </b-col>
                  <b-col md="4" class="mb-1" v-if="getBRFList.CargoWeight">
                    <strong>Cargo Weight:</strong>
                    {{ getBRFList.CargoWeight  || "N/A" }} kg
                  </b-col>
                  <b-col md="4" class="mb-1" v-if="getBRFList.CommodityItemName">
                    <strong>Commodity Item Name:</strong>
                    {{ getBRFList.CommodityItemName  || "N/A" }}
                  </b-col>
                  <b-col md="4" class="mb-1" v-if="getBRFList.CommodityHsnCode">
                    <strong>Commodity HSN Code:</strong>
                    {{ getBRFList.CommodityHsnCode  || "N/A" }}
                  </b-col>
                  <b-col md="4" class="mb-1" v-if="getBRFList.CommodityItemHsnCode">
                    <strong>Commodity Item HSN Code:</strong>
                    {{ getBRFList.CommodityItemHsnCode  || "N/A" }}
                  </b-col>
                </b-row>

                <hr />

                <!-- Rate and Free Days Section -->
                <h6 class="card-title">Rate & Free Days</h6>
                <b-row>
                  <b-col md="4" class="mb-1" v-if="getBRFList.RateAgreed">
                    <strong>Rate Agreed:</strong> {{ getBRFList.RateAgreed  || "N/A" }}
                  </b-col>
                  <b-col md="4" class="mb-1" v-if="getBRFList.FreeDays">
                    <strong>FREE DAYS AT POD:</strong> {{ getBRFList.FreeDays  || "N/A" }}
                  </b-col>
                  <b-col md="4" class="mb-1" v-if="getBRFList.SiCutOfDate">
                    <strong>SI CUT OFF:</strong> {{ getBRFList.SiCutOfDate  || "N/A" }}
                  </b-col>
                   <b-col md="4" class="mb-1" v-if="getBRFList.FreightTermsMbl">
                    <strong>FREIGHT TERMS ( MBL):</strong> {{ getBRFList.FreightTermsMbl  || "N/A" }}
                  </b-col>
                   <b-col md="4" class="mb-1" v-if="getBRFList.FreightTermsHbl">
                    <strong>FREIGHT TERMS HBL:</strong> {{ getBRFList.FreightTermsHbl  || "N/A" }}
                  </b-col>
                   <b-col md="4" class="mb-1" v-if="getBRFList.DestinationCharges">
                    <strong>DESTINATION CHARGES:</strong> {{ getBRFList.DestinationCharges  || "N/A" }}
                  </b-col>
                   <b-col md="4" class="mb-1" v-if="getBRFList.DestinationChargesDet">
                    <strong>DESTINATION CHARGES Det.:</strong> {{ getBRFList.DestinationChargesDet  || "N/A" }}
                  </b-col>
                   <b-col md="4" class="mb-1" v-if="getBRFList.FirstMileBooking">
                    <strong>FIRST MILE BOOKING:</strong> {{ getBRFList.FirstMileBooking  || "N/A" }}
                  </b-col>
                </b-row>

                <hr />

                <!-- Instructions and Remarks Section -->
                <h6 class="card-title">Instructions & Remarks</h6>
                <b-row>
                  <b-col md="6" class="mb-1" v-if="getBRFList.BlInstruction">
                    <strong>BL Instruction:</strong>
                    {{ getBRFList.BlInstruction  || "N/A" }}
                  </b-col>
                  <b-col md="6" class="mb-1" v-if="getBRFList.Remarks">
                    <strong>Remarks:</strong>
                    {{ getBRFList.Remarks  || "N/A" }}
                  </b-col>
                </b-row>

                <hr />

                <!-- Agent Details Section -->
                <h6 class="card-title">Agent Details</h6>
                <b-row>
                  <b-col md="4" class="mb-1" v-if="getBRFList.AgentCategoryType">
                    <strong>Agent Category Type:</strong>
                    {{ getBRFList.AgentCategoryType  || "N/A" }}
                  </b-col>
                  <b-col md="4" class="mb-1" v-if="getBRFList.AgentName">
                    <strong>Agent Name:</strong> {{ getBRFList.AgentName  || "N/A" }}
                  </b-col>
                  <b-col md="4" class="mb-1" v-if="getBRFList.CoLoaderName">
                    <strong>Co-Loader Name:</strong>
                    {{ getBRFList.CoLoaderName  || "N/A" }}
                  </b-col>
                </b-row>

                <hr />

                <!-- Status Flags Section -->
                <h6 class="card-title">Status Flags</h6>
                <b-row>
                  <b-col md="4" class="mb-1" v-if="getBRFList.IsUsed">
                    <strong>Is Used:</strong>
                    <span :class="flagClass(getBRFList.IsUsed)">
                      {{ getBRFList.IsUsed === "Yes" ? "Yes" : "No" }}
                    </span>
                  </b-col>
                  <b-col md="4" class="mb-1" v-if="getBRFList.IsActive">
                    <strong>Is Active:</strong>
                    <span :class="flagClass(getBRFList.IsActive)">
                      {{ getBRFList.IsActive === "Yes" ? "Active" : "Inactive" }}
                    </span>
                  </b-col>
                  <b-col md="4" class="mb-1" v-if="getBRFList.IsDeleted">
                    <strong>Is Deleted:</strong>
                    <span :class="flagClass(getBRFList.IsDeleted)">
                      {{ getBRFList.IsDeleted === "Yes" ? "Yes" : "No" }}
                    </span>
                  </b-col>
                  <b-col md="4" class="mb-1" v-if="getBRFList.IsEnqPricingClosed">
                    <strong>Is Enquiry Pricing Closed:</strong>
                    <span :class="flagClass(getBRFList.IsEnqPricingClosed)">
                      {{ getBRFList.IsEnqPricingClosed === "Yes" ? "Closed" : "Open" }}
                    </span>
                  </b-col>
                  <b-col md="4" class="mb-1" v-if="getBRFList.IsEnqPricingUsed">
                    <strong>Is Enquiry Pricing Used:</strong>
                    <span :class="flagClass(getBRFList.IsEnqPricingUsed)">
                      {{ getBRFList.IsEnqPricingUsed === "Yes" ? "Used" : "Not Used" }}
                    </span>
                  </b-col>
                  <b-col md="4" class="mb-1" v-if="getBRFList.IsEnqPricingActive">
                    <strong>Is Enquiry Pricing Active:</strong>
                    <span :class="flagClass(getBRFList.IsEnqPricingActive)">
                      {{
                        getBRFList.IsEnqPricingActive === "Yes" ? "Active" : "Inactive"
                      }}
                    </span>
                  </b-col>
                </b-row>

                <hr />

                <!-- Container Details Section -->
                <h6 class="card-title">Container Details</h6>
                <b-row>
                  <b-col md="4" class="mb-1" v-if="getBRFList.ContainerType">
                    <strong>Container Type:</strong>
                    {{ getBRFList.ContainerType  || "N/A" }}
                  </b-col>
                  <b-col md="4" class="mb-1" v-if="getBRFList.TuesCount">
                    <strong>Tues Count:</strong> {{ getBRFList.TuesCount  || "N/A" }}
                  </b-col>
                </b-row>

                <hr />


                <!-- PRBR Details Section -->
                <h6 class="card-title">PRBR Details</h6>
                <b-row>
                  <b-col md="4" class="mb-1" v-if="getBRFList.prbr_is_used">
                    <strong>PRBR Is Used:</strong>
                    {{ getBRFList.prbr_is_used === 1 ? "Yes" : "No"  }}
                  </b-col>
                  <b-col md="4" class="mb-1" v-if="getBRFList.prbr_is_active">
                    <strong>PRBR Is Active:</strong>
                    {{ getBRFList.prbr_is_active === 1 ? "Active" : "Inactive"  }}
                  </b-col>
                  <b-col md="4" class="mb-1" v-if="getBRFList.prbr_is_deleted">
                    <strong>PRBR Is Deleted:</strong>
                    {{ getBRFList.prbr_is_deleted === 1 ? "Yes" : "No" }}
                  </b-col>
                  <b-col md="4" class="mb-1" v-if="getBRFList.is_new_book_resp">
                    <strong>Is New Book Resp:</strong>
                    {{ getBRFList.is_new_book_resp === 1 ? "Yes" : "No" }}
                  </b-col>
                  <b-col md="4" class="mb-1" v-if="getBRFList.prbr_id">
                    <strong>PRBR ID:</strong> {{ getBRFList.prbr_id  || "N/A" }}
                  </b-col>
                </b-row>

                <hr />

                <!-- Additional Details Section -->
                <h6 class="card-title">Additional Details</h6>
                <b-row>
                  <b-col md="4" class="mb-1" v-if="getBRFList.companyType">
                    <strong>Type of Company:</strong>
                    {{ getBRFList.companyType  || "N/A" }}
                  </b-col>
                  <b-col md="4" class="mb-1" v-if="getBRFList.stateName">
                    <strong>State:</strong> {{ getBRFList.stateName  || "N/A" }}
                  </b-col>
                  <b-col md="4" class="mb-1" v-if="getBRFList.permitted">
                    <strong>Company Permitted:</strong>
                    {{ getBRFList.permitted || "N/A" }}
                  </b-col>
                  <b-col md="4" class="mb-1" v-if="getBRFList.tanNO">
                    <strong>TAN No:</strong> {{ getBRFList.tanNO || "N/A" }}
                  </b-col>
                  <b-col md="4" class="mb-1" v-if="getBRFList.GSTN">
                    <strong>GSTN No:</strong> {{ getBRFList.GSTN  || "N/A" }}
                  </b-col>
                  <b-col md="4" class="mb-1" v-if="getBRFList.corporateAddress">
                    <strong>Corporate Address:</strong>
                    {{ getBRFList.corporateAddress  || "N/A" }}
                  </b-col>
                  <b-col md="4" class="mb-1" v-if="getBRFList.Pda">
                    <strong>PDA:</strong> {{ getBRFList.Pda  || "N/A" }}
                  </b-col>
                </b-row>

                <!-- Add more BRF details as needed -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-button @click="hideviewBRFDetails" variant="danger" class="pull-right mt-2">
        Close</b-button
      >
    </b-modal>
    <!-- Filter BRF Modal End -->
  </div>
</template>

<script>
import CustomLoader from "./customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import NodeLockPannelService from "../../services/NodeLockPannelService.js";
export default {
  props: {
    BRFDetails: Object,
    prbr_id: Number,
  },
  data() {
    return {
      isLoading: false,
      fadeIn: false,
      getBRFList: {},
      CONTAINERCOUNTArr: [],
      brf_id: this.prbr_id,
    };
  },
  components: {
    CustomLoader,
  },
  mounted() {
    // Set fadeIn to true after the component is mounted to trigger the animation
    this.fadeIn = true;
  },
  methods: {
    flagClass(flag) {
      if (flag === "Yes" || flag === 1) {
        return "success";
      } else if (flag === "No" || flag === 0) {
        return "danger";
      } else {
        return "muted";
      }
    },
    viewBRFDetails() {
      // this.brf_id = 0;
      this.getBRFDetails();
      this.$refs["viewBRFDetails-modal"].show();
    },
    hideviewBRFDetails() {
      this.brf_id = 0;
      this.$refs["viewBRFDetails-modal"].hide();
    },

    getBRFDetails() {
      this.isLoading = true;
      this.getBRFList = {};
      this.CONTAINERCOUNTArr = [];
      if (this.brf_id > 0) {
        NodeLockPannelService.getSingleNewBookingResp(this.brf_id)
          .then((response) => {
            const { data, status, success } = response;
            console.log("this.getBRFList=",this.getBRFList)
            if (status == 200 && data && data.success == true) {
              this.isLoading = false;
              this.getBRFList = data.allLockPanelData;
              this.CONTAINERCOUNTArr = data.data.containerTypeDet
                ? JSON.parse(data.data.containerTypeDet)
                : [];
              this.fadeIn = true;
            }
          })
          .catch((error) => {
            console.log("Catch on getBRFDetails Error: ", error);
          });
      }
    },
  },
};
</script>
<style scoped>
.card {
  border: 1px solid #ddd;
  border-radius: 8px;
  margin: 10px;
  overflow: hidden;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, opacity 0.5s ease;
}

.card:hover {
  transform: scale(1.05);
}

.card-header {
  background-color: #3498db;
  color: #b90f0f;
  padding: 10px;
  font-weight: bold;
}

.card-body {
  padding: 15px;
}

.client-details {
  margin-top: 10px;
  color: #555555;
}

a {
  color: #3498db;
  text-decoration: none;
  font-weight: bold;
}

a:hover {
  text-decoration: underline;
}

/* Fade-in Animation */
.fade-in {
  opacity: 0;
}

.fade-in-enter-active {
  transition: opacity 0.5s;
}

.fade-in-enter-to {
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// brfCard.vue?11f6c150